import { render, staticRenderFns } from "./NumberGraph.vue?vue&type=template&id=0083a99a&"
import script from "./NumberGraph.vue?vue&type=script&lang=js&"
export * from "./NumberGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports